module.exports = __webpack_public_path__ + "static/media/tz.e674e484.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/wxMini/tz.png
// module id = 446
// module chunks = 0